import { Injectable, Inject, HostListener } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { ContractComponent } from './contract.component';

@Injectable()
export class PendingChangesGuard implements CanDeactivate<ContractComponent> {
  
  canDeactivate(target: ContractComponent) {
    if (target.hasChanges()) {
        return window.confirm('Imate nespremljenih promjena. Napuštanjem ove stranice promjene će biti izgubljene. Jeste li sigurni da želite napustiti stranicu?');
    }
    return true;
  }

}


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contract/contract.guard.ts